import { render } from "./OverallPerformanceCard.vue?vue&type=template&id=37dfcdb0&scoped=true"
import script from "./OverallPerformanceCard.vue?vue&type=script&lang=js"
export * from "./OverallPerformanceCard.vue?vue&type=script&lang=js"

import "./OverallPerformanceCard.vue?vue&type=style&index=0&id=37dfcdb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dfcdb0"]])

export default __exports__